module.exports = __webpack_public_path__ + "static/media/Group 2516.1d79040f.svg";